import { render, staticRenderFns } from "./DialogCreateChannel.vue?vue&type=template&id=71225de4&scoped=true&"
import script from "./DialogCreateChannel.vue?vue&type=script&lang=ts&"
export * from "./DialogCreateChannel.vue?vue&type=script&lang=ts&"
import style0 from "./DialogCreateChannel.vue?vue&type=style&index=0&id=71225de4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71225de4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VForm,VImg,VSheet,VTextField,VTextarea})
